import React, { createContext, PropsWithChildren, useContext, useState } from 'react'

export interface NavHeaderState {
  isTierTwoMenuVisible: boolean
}

export interface NavHeaderContextModel extends NavHeaderState {
  hideTierTwoMenu?: () => void
  showTierTwoMenu?: () => void
}

const uninitializedNavHeader: NavHeaderContextModel = {
  isTierTwoMenuVisible: true,
  hideTierTwoMenu: () => {
    console.error('hideTierTwoMenu context is not initialized')
  },
  showTierTwoMenu: () => {
    console.error('showTierTwoMenu context is not initialized')
  },
}

export const NavHeaderContext = createContext<NavHeaderContextModel>(uninitializedNavHeader)

export const useNavHeader = (): NavHeaderContextModel => useContext(NavHeaderContext)

const NavHeaderProvider = ({ children }: PropsWithChildren) => {
  const [isTierTwoMenuVisible, setTierTwoVisible] = useState(true)

  return (
    <NavHeaderContext.Provider
      value={{
        isTierTwoMenuVisible: isTierTwoMenuVisible,
        hideTierTwoMenu: (): void => setTierTwoVisible(false),
        showTierTwoMenu: (): void => setTierTwoVisible(true),
      }}
    >
      {children}
    </NavHeaderContext.Provider>
  )
}

export default NavHeaderProvider
